import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import AssetForm from './AssetForm';
import AssetPieChart from './AssetPieChart';
import './Dashboard.css';
import { FaUserCircle, FaQuestionCircle, FaSignOutAlt } from 'react-icons/fa';
import EditForm from './EditForm';
import NewEntryForm from './NewEntryForm';


const Dashboard = ({ onLogout, onHelp }) => {
  const [data, setData] = useState({ totalAssets: 0, recentAssets: [] });
  const [tableColumns, setTableColumns] = useState([]);
  const [editingRow, setEditingRow] = useState(null);
  const [editFormData, setEditFormData] = useState({});
  const [showSidebar, setShowSidebar] = useState(window.innerWidth >= 768);
  const [tables, setTables] = useState([]);
  const [selectedTable, setSelectedTable] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);
  const [showNewForm, setShowNewForm] = useState(false);
  const [newFormData, setNewFormData] = useState({});
  const [showTables, setShowTables] = useState(false);
  const [activeView, setActiveView] = useState('dashboard'); // 'dashboard', 'table', 'form'
  

useEffect(() => {
  const handleResize = () => {
    if (window.innerWidth >= 768) {
      setShowSidebar(true);  // Show by default on desktop
    } else {
      setShowSidebar(false); // Hide on mobile
    }
  };

  window.addEventListener("resize", handleResize);
  handleResize(); // initial check

  return () => window.removeEventListener("resize", handleResize);
}, []);


  useEffect(() => {
    axios.get('https://testone.onebox.pk/api/data')
       .then(res => {
      console.log("🚀 /api/data response:", res.data);  // 👈 Add this
      setData(res.data);
    })
      .catch(console.error);

    axios.get('https://testone.onebox.pk/api/tables')
      .then(res => setTables(res.data))
      .catch(console.error);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const fetchTableData = (tableName, query = '') => {
    const url = query
      ? `https://testone.onebox.pk/api/search/${tableName}?q=${query}`
      : `https://testone.onebox.pk/api/table/${tableName}`;

    axios.get(url)
      .then(res => {
        setTableData(res.data);
        if (res.data.length > 0) {
          setTableColumns(Object.keys(res.data[0]));
        } else {
          setTableColumns([]);
        }
      })
      .catch(error => {
        console.error("Error loading table:", error);
        alert("Failed to load table data.");
      });
  };

  const handleTableClick = (tableName) => {
      setActiveView('table'); 
    setSelectedTable(tableName);
    setSearchTerm('');
    setShowSidebar(false);
    fetchTableData(tableName);
  };

  const handleView = (row) => {
    alert(`Viewing row:\n${JSON.stringify(row, null, 2)}`);
  };

  const handleEdit = (row) => {
    setEditingRow(row.id);
    setEditFormData({ ...row });
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleDelete = (row) => {
    const confirmed = window.confirm("Are you sure you want to delete this record?");
    if (!confirmed) return;

    axios
      .delete(`https://testone.onebox.pk/api/table/${selectedTable}/${row.id}`)
      .then(() => {
        setTableData(prev => prev.filter(r => r.id !== row.id));
        alert("Deleted successfully.");
      })
      .catch((err) => {
        console.error("Delete failed:", err);
        alert("Failed to delete row.");
      });
  };

  const handleEditSubmit = (e) => {
    e.preventDefault();

    axios
      .put(`https://testone.onebox.pk/api/table/${selectedTable}/${editingRow}`, editFormData)
      .then((res) => {
        setTableData(prev =>
          prev.map(row => (row.id === editingRow ? res.data : row))
        );
        setEditingRow(null);
        alert("Record updated successfully!");
      })
      .catch((err) => {
        console.error("Update failed:", err);
        alert("Failed to update record.");
      });
  };

  const handleNewChange = (e) => {
  const { name, value } = e.target;
  setNewFormData(prev => ({ ...prev, [name]: value }));
};

const handleNewSubmit = (e) => {
  e.preventDefault();
  axios
    .post(`https://testone.onebox.pk/api/table/${selectedTable}`, newFormData)
    .then(res => {
      setTableData(prev => [...prev, res.data]);
      setShowNewForm(false);
      setNewFormData({});
      alert("New record added successfully!");
    })
    .catch(err => {
      console.error("Add failed:", err);
      alert("Failed to add new record.");
    });
};


  return (
    <div className={`dashboard-container ${showSidebar ? 'sidebar-open' : ''}`}>
      {showSidebar && <div className="overlay" onClick={() => setShowSidebar(false)} />}

    {/* Sidebar */}
<div className={`sidebar ${showSidebar ? 'show' : ''} bg-dark text-white`}>
  <h4 className="sidebar-title text-white ps-4 py-3 mb-0 border-bottom">Menu</h4>

  <div className="d-flex flex-column px-3 mt-3">

    {/* Sidebar Search */}
    <div className="input-group mb-3 ml-3">
      <input
        type="text"
        className="form-control form-control-sm"
        placeholder="Search tables..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
    </div>
 
{/* 📊 Dashboard Button */}
    <button
      className={`btn btn-outline-light text-start sidebar-btn mb-2 ${activeView === 'dashboard' ? 'active' : ''}`}
      onClick={() => {
        setActiveView('dashboard');  // show dashboard content
        setSelectedTable(null);      // hide table if visible
        setShowSidebar(false);       // optional: close sidebar on mobile
      }}
    >
      📊 Dashboard
    </button>

    {/* Asset Form Button */}
    <button
      className={`btn btn-outline-light text-start sidebar-btn mb-2 ${activeView === 'form' ? 'active' : ''}`}

      onClick={() => {
        setActiveView('form');  // show asset form
        setSelectedTable(null); // hide table view
        setShowSidebar(false);  // optional: close sidebar on mobile
      }}
    >
      🧾 Asset Form
    </button>

   {/* Tables Dropdown Toggle */}
<button
  className="btn  text-start sidebar-btn mb-2"
  onClick={() => setShowTables(prev => !prev)}
>
  📂 Tables {showTables ? '▲' : '▼'}
</button>

{/* Filtered Table List */}
{showTables && (
  <div className="ps-2 mt-1">
    <ul className="list-unstyled">
      {tables
        .filter((table) =>
          table.toLowerCase().includes(searchTerm.toLowerCase())
        )
        .map((table, idx) => (
          <li key={idx} className="mb-1">
            <button
              onClick={() => {
                handleTableClick(table);
                setShowSidebar(false); // Close sidebar on selection
              }}
              className="btn btn-sm btn-light w-100 text-start sidebar-table-btn"
            >
              {table}
            </button>
          </li>
        ))}

      {/* No Match Message */}
      {tables.filter((table) =>
        table.toLowerCase().includes(searchTerm.toLowerCase())
      ).length === 0 && (
        <li className="text-white-50 ps-2 small">No matching tables</li>
      )}
    </ul>
  </div>
)}

  </div>
</div>


    <div className="main-content">
  <div className="d-flex justify-content-between align-items-center mb-4 px-3 py-2 border-bottom">
    <div className="d-flex align-items-center">
        {/* Mobile Menu Button - Only visible on small screens */}
<button
  className="btn btn-dark sidebar-toggle-btn me-3 mb-3"
  onClick={() => setShowSidebar(true)}
>
  ☰
</button>
     <br/>
            <img src="/logo.png" alt="Logo" className="main-logo" />
            
          
            <center><h2>Welcome to Asset Management System</h2></center>
          </div>

          <div className="user-dropdown-container" ref={dropdownRef}>
            <FaUserCircle
              size={32}
              className="user-icon"
              onClick={() => setShowDropdown(!showDropdown)}
            />
            {showDropdown && (
              <div className="user-dropdown">
                <button className="dropdown-item" onClick={onHelp}>
                  <FaQuestionCircle className="dropdown-icon" /> Help
                </button>
                <div className="dropdown-divider mr-3"></div>
                <button className="dropdown-item logout" onClick={onLogout}>
                  <FaSignOutAlt className="dropdown-icon" /> Log Out
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Main Panel Content */}
       {editingRow && editFormData ? (
              <EditForm
                data={editFormData}
                onChange={handleEditChange}
                onCancel={() => setEditingRow(null)}
                onSubmit={handleEditSubmit}
              />
            ) : showNewForm ? (
              <NewEntryForm
                columns={tableColumns}
                formData={newFormData}
                onChange={handleNewChange}
                onCancel={() => setShowNewForm(false)}
                onSubmit={handleNewSubmit}
              />
            ) : activeView === 'form' ? (
          <div className="px-3 mt-4">
            <AssetForm />
          </div>
            ) : activeView === 'dashboard' ? (
          <div className="px-3 mb-5 ml-3">
  <div className="row g-4">
    {/* Left Column: Total Asset Count */}
    <div className="col-lg-6">
      <div className="bg-white p-4 shadow-sm rounded-4 text-center h-100 d-flex flex-column justify-content-center">
        <h4 className="text-muted text-uppercase">Total Assets</h4>
        <h1 className="fw-bold text-success display-4 mb-0">{data.totalAssets}</h1>
        <hr className="my-3" />
        <p className="text-muted">Updated summary of all registered assets</p>
      </div>
    </div>

    {/* Right Column: Pie Chart */}
    <div className="col-lg-6">
      <div className="bg-white p-4 shadow-sm rounded-4 h-100">
        <h4 className="text-primary fw-bold mb-3">📊 Assets by Category</h4>
        <AssetPieChart />
      </div>
    </div>
  </div>

  {/* Recent Asset Records */}
  <div className="mt-5">
    <h4 className="fw-semibold mb-3">📋 Last 10 Asset Records</h4>
   <div className="table-responsive bg-white rounded-4 shadow-sm p-4">
  <table className="table table-hover table-striped table-bordered align-middle text-center">
    <thead className="bg-primary text-white rounded-top">
      <tr>
        <th className="text-uppercase">📦 Asset Name</th>
        <th className="text-uppercase">📁 Category</th>
        <th className="text-uppercase">📅 Purchase Date</th>
        <th className="text-uppercase">💰 Cost</th>
      </tr>
    </thead>
    <tbody>
      {data.recentAssets && data.recentAssets.length > 0 ? (
        data.recentAssets.map((asset, i) => (
          <tr key={i} className="align-middle">
            <td>{asset.asset_name}</td>
            <td>{asset.category}</td>
            <td>{new Date(asset.purchase_date).toLocaleDateString()}</td>
            <td className="fw-semibold text-success">Rs. {parseFloat(asset.book_value).toLocaleString()}</td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan="4" className="text-center text-muted py-4">
            🚫 No recent asset records found.
          </td>
        </tr>
      )}
    </tbody>
  </table>
</div>

  </div>
</div>

        ) : (
          <div className="d-flex justify-content-center mt-4 px-3">
            <div className="w-100" style={{ maxWidth: '1000px' }}>
              <div className="card-body p-4" style={{ marginLeft: showSidebar ? '280px' : '0px' }}>
                <div className="table-view-container px-4">
                  {/* Header Section */}
                  <div className="mb-4 px-2 py-2 bg-white border rounded d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center shadow-sm">
                   
                    <center><h3 className="text-primary fw-bold mb-0">
                      📋 Viewing: {selectedTable}
                    </h3></center>
                  </div>

                  {/* Search Bar */}
                  <div className=" d-flex justify-content-between-align-items-center mb-3 px-3 mr-3">
                      <input
                        type="text"
                        className="table-search-bar"
                        placeholder={`🔍 Search in ${selectedTable}...`}
                        value={searchTerm}
                        onChange={(e) => {
                          const val = e.target.value;
                          setSearchTerm(val);
                          fetchTableData(selectedTable, val);
                        }}
                      />
                      <div className="btn btn-success ms-3">
                      <button className="btn btn-primary shadow-sm fw-bold px-4 py-2 rounded-pill" onClick={() => setShowNewForm(true)}>
                      Add New Recoerd
                      </button>
                       </div>
                    </div>

                  {/* Table */}
                  <div className="card shadow rounded-4 border-0 mr-3">
                    <div className="table-responsive rounded-3">
                      <table className="table table-bordered table-hover align-middle text-center table-striped custom-table">
                        <thead className="table-primary text-white">
                          <tr>
                            {tableData[0] &&
                              Object.keys(tableData[0]).map((key, idx) => (
                                <th key={idx} className="text-uppercase">{key.replace(/_/g, ' ')}</th>
                              ))}
                            <th>ACTIONS</th>
                          </tr>
                        </thead>
                        <tbody>
                          {tableData.map((row, idx) => (
                            <tr key={idx}>
                              {Object.values(row).map((val, i) => (
                                <td key={i}>{String(val)}</td>
                              ))}
                              <td>
                                <button className="btn btn-sm btn-info me-1" onClick={() => handleView(row)}>👁 View</button>
                                <button className="btn btn-sm btn-warning me-1" onClick={() => handleEdit(row)}>✏️ Edit</button>
                                <button className="btn btn-sm btn-danger" onClick={() => handleDelete(row)}>🗑 Delete</button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>

                      {/* Inline Edit Form */}
                      {editingRow && (
                        <div className="mt-4">
                          <h5 className="text-primary">✏️ Edit Record</h5>
                          <form onSubmit={handleEditSubmit} className="row g-3">
                            {Object.entries(editFormData).map(([key, value]) => (
                              <div className="col-md-6" key={key}>
                                <label className="form-label text-capitalize">{key.replace(/_/g, ' ')}</label>
                                <input
                                  type="text"
                                  name={key}
                                  value={value || ''}
                                  onChange={handleEditChange}
                                  className="form-control"
                                  disabled={key === 'id'}
                                />
                              </div>
                            ))}
                            <div className="col-12">
                              <button type="submit" className="btn btn-success me-2">💾 Save</button>
                              <button type="button" className="btn btn-secondary" onClick={() => setEditingRow(null)}>Cancel</button>
                            </div>
                          </form>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;  